import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FlatpickrDirective, provideFlatpickrDefaults } from 'angularx-flatpickr';
import { Swedish } from 'flatpickr/dist/l10n/sv.js';
import moment from 'moment';

@Component({
  imports: [FlatpickrDirective, FormsModule],
  providers: [
    provideFlatpickrDefaults({
      weekNumbers: true,
      getWeek: (date: Date): string => {
        // ISO week date calculation
        const d = new Date(date.valueOf());
        const dayNum = d.getDay() || 7;
        d.setDate(d.getDate() + 4 - dayNum);
        const yearStart = new Date(d.getFullYear(), 0, 1);
        return String(Math.ceil(((d.getTime() - yearStart.getTime()) / 86400000 + 1) / 7));
      },
      locale: Swedish,
      dateFormat: 'Y-m-d',
      altFormat: 'Y VW',
    }),
  ],
  template: `
    <div class="input-group input-group-sm">
      <input
        #flatpickrInput
        type="text"
        mwlFlatpickr
      [(ngModel)]="selectedDate2"
      (ngModelChange)="onDateChange($event)"
      [altInput]="true"
      [convertModelValue]="true"
      [disabled]="disabled"
      [dateFormat]="dateFormat"
      [altFormat]="altFormat"
      [weekNumbers]="weekNumbers"
      [locale]="swedishLocale"
      [placeholder]="placeholder"
      class="form-control"
      />
      <span class="input-group-btn">
        <button
          class="btn btn-default"
          type="button"
          (click)="toggleCalendar()"
          [disabled]="disabled"
        >
          <i class="fa fa-calendar"></i>
        </button>
      </span>
    </div>
  `,
  styles: [
    `
      .bs5-iso .input-group-sm > .form-control {
        font-size: 14px;
      }
      .bs5-iso .input-group-sm > input.flatpickr-input {
        font-size: 14px;
      }
    `,
  ],
  standalone: true,
  selector: 'app-datepicker',
})
export class AppDatepickerComponent implements OnInit, AfterViewInit {
  @ViewChild('flatpickrInput', { static: false }) flatpickrInput!: ElementRef;

  @Input()
  set date(value: moment.Moment | null) {
    if (value && moment.isMoment(value)) {
      this.selectedDate2 = value.toDate();
    } else {
      this.selectedDate2 = undefined;
    }
  }

  @Input() disabled = false;
  @Input() dateFormat = 'Y-m-d';
  @Input() altFormat = 'Y VW';
  @Input() weekNumbers = true;
  @Input() placeholder = '';

  @Output() dateChange = new EventEmitter<moment.Moment | null>();

  selectedDate2: Date | undefined = undefined;
  private flatpickrInstance: any;
  protected readonly swedishLocale = Swedish;

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    // Get reference to flatpickr instance
    if (this.flatpickrInput && this.flatpickrInput.nativeElement) {
      this.flatpickrInstance = (this.flatpickrInput.nativeElement as any)._flatpickr;
    }
  }

  toggleCalendar(): void {
    if (this.flatpickrInstance) {
      this.flatpickrInstance.toggle();
    }
  }

  onDateChange(date: Date | undefined): void {
    this.selectedDate2 = date;
    this.dateChange.emit(date ? moment(date) : null);
  }
}
